export default "__VITE_ASSET__95459599__"